import { memo } from 'react';

import { PlusIcon, UploadIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';

export type ContributableNullStateActionsProps = {
  createOptions: DropdownMenuOption[];
  onOpenChange: (isExpanded: boolean) => void;
  uploadOptions: DropdownMenuOption[];
};

export const ContributableNullStateActions = memo(
  ({ createOptions, onOpenChange, uploadOptions }: ContributableNullStateActionsProps) => (
    <>
      {uploadOptions.length > 0 && (
        <DropdownMenu
          size="small"
          trigger={
            <Button
              appearance="filled"
              color="blue"
              data-testid="CONTRIBUTABLE_NULL_STATE_UPLOAD_BUTTON"
              prefix={<UploadIcon size="sm" />}
              size="medium"
            >
              Upload content
            </Button>
          }
          onOpenChange={onOpenChange}
        >
          {renderDropdownItems({ options: uploadOptions, size: 'small' })}
        </DropdownMenu>
      )}
      {createOptions.length > 0 && (
        <DropdownMenu
          size="small"
          trigger={
            <Button
              appearance="outline"
              color="blue"
              data-testid="CONTRIBUTABLE_NULL_STATE_CREATE_BUTTON"
              prefix={<PlusIcon size="sm" />}
              size="medium"
            >
              Create
            </Button>
          }
          onOpenChange={onOpenChange}
        >
          {renderDropdownItems({ options: createOptions, size: 'small' })}
        </DropdownMenu>
      )}
    </>
  ),
);

ContributableNullStateActions.displayName = 'ContributableNullStateActions';
